import {
  buildIcs,
  googleCalendarUrl,
  hhmm,
  outlookCalendarUrl,
  type CalendarEvent,
} from '@jobfair/shared';
import { useTrack } from '../lib/trackerContext';
import type { LiveState, Phase, Site } from '../types';
import { Icon } from './Icon';

export function calendarEvent(site: Site, st: LiveState, ph: Phase): CalendarEvent | null {
  if (!ph.valid || !st.date) return null;
  return {
    title: `${site.fairName} – ${site.org}`,
    details: `${site.intro}\n\nכניסה לאתר היריד: ${location.href.split('#')[0]}`,
    date: st.date,
    startHm: st.convStart,
    endHm: hhmm(ph.R[2]!.end),
  };
}

export function CalLinks({ site, st, ph }: { site: Site; st: LiveState; ph: Phase }) {
  const track = useTrack();
  const ev = calendarEvent(site, st, ph);
  if (!ev) return null;

  const downloadIcs = () => {
    track('calendar_add', { value: 'ics' });
    const ics = buildIcs(ev, `jobfair-${st.date}@codex.co.il`, Date.now());
    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'jobfair.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  return (
    <div className="cal">
      <Icon n="cal" s={15} />
      הוספה ליומן:
      <a
        href={googleCalendarUrl(ev)}
        target="_blank"
        rel="noopener"
        onClick={() => track('calendar_add', { value: 'google' })}
      >
        Google
      </a>
      <a
        href={outlookCalendarUrl(ev)}
        target="_blank"
        rel="noopener"
        onClick={() => track('calendar_add', { value: 'outlook' })}
      >
        Outlook
      </a>
      <a href="#ics" onClick={(e) => (e.preventDefault(), downloadIcs())}>
        קובץ ICS
      </a>
    </div>
  );
}
